'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  eventTypes: function eventTypes(params) {
    return _client2.default.get('1/event_types', params);
  },
  amenities: function amenities(params) {
    return _client2.default.get('1/amenities', params);
  },
  spaceTypes: function spaceTypes(params) {
    return _client2.default.get('1/space_types', params);
  },
  countries: function countries(params) {
    return _client2.default.get('1/countries', params);
  },
  largeAreas: function largeAreas(countryId, params) {
    return _client2.default.get('1/countries/' + countryId + '/large_areas', params);
  },
  mediumAreas: function mediumAreas(countryId, largeAreaName, params) {
    return _client2.default.get('1/countries/' + countryId + '/large_areas/' + largeAreaName + '/medium_areas', params);
  },
  capacities: function capacities(params) {
    return _client2.default.get('1/capacities', params);
  },
  jobs: function jobs(params) {
    return _client2.default.get('1/jobs', params);
  },
  industries: function industries(params) {
    return _client2.default.get('1/industries', params);
  },
  channelTypes: function channelTypes(params) {
    return _client2.default.get('1/channel_types', params);
  },
  reservationStatuses: function reservationStatuses(params) {
    return _client2.default.get('1/reservation_statuses', _extends({}, params, {
      type: 'manual_reservation'
    }));
  },
  timeZones: function timeZones(params) {
    return _client2.default.get('1/time_zones', params);
  },
  roomFeatures: function roomFeatures(params) {
    return _client2.default.get('1/room_features', params);
  },
  keyExchangeTypes: function keyExchangeTypes(params) {
    return _client2.default.get('1/key_exchange_types', params);
  },
  reservableStarts: function reservableStarts(params) {
    return _client2.default.get('1/reservable_starts', params);
  },
  reservableDurations: function reservableDurations(params) {
    return _client2.default.get('1/reservable_durations', params);
  },
  roomTypes: function roomTypes(params) {
    return _client2.default.get('1/room_types', params);
  },
  planDiscountPercentages: function planDiscountPercentages(params) {
    return _client2.default.get('1/plan_discount_percentages', params);
  },
  stayCertificationTypes: function stayCertificationTypes(params) {
    return _client2.default.get('1/stay_certification_types', params);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/rest/resources/master.js
// module id = 837
// module chunks = 0